import { useMemo } from "react";
import { useListProjectServices } from "../../ProjectServicesV2/common/api";
import useListGovernances from "../../GovernanceV2/Show/api/useListGovernances";
import { useListProjectResources } from "../../Projects/ServicesV2/api";
import { getResourceName } from "../../Projects/ServicesV2/common";
import { flattenLines, toScopeServices } from "./scopeLines";
import type { ResourceOption } from "./ChangeScopeGrid";

// The parent project's lines, governance and resources for the builder.
export const useBuilderData = (projectId: string) => {
  const ps = useListProjectServices({ project_id: projectId, service_type: "professional_services" });
  const ms = useListProjectServices({ project_id: projectId, service_type: "managed_services" });
  // project-phase must be included and phases/lobs passed, or the hook's
  // mapping throws (see useListGovernances).
  const gov = useListGovernances({
    page: { size: 500 },
    include: ["resource", "project-phase", "project-resource", "project", "service-category"],
    filter: { project: projectId, active: true },
    projectPhases: [],
    lobs: [],
  } as any);
  const { projectResources, projectResourcesLoading } = useListProjectResources(projectId);

  return useMemo(() => {
    const professional = toScopeServices(ps.fetchedServices ?? []);
    const managed = toScopeServices(ms.fetchedServices ?? []);
    const resourceOptions: ResourceOption[] = (projectResources ?? []).map((r: any) => ({
      value: String(r.id),
      label: getResourceName(r),
    }));
    return {
      professional,
      managed,
      lines: flattenLines([...professional, ...managed]),
      governances: gov.data ?? [],
      resourceOptions,
      isLoading: Boolean(ps.servicesLoading || ms.servicesLoading || gov.governancesLoading || projectResourcesLoading),
      error: Boolean(ps.error || ms.error || gov.governancesError),
    };
  }, [ps.fetchedServices, ms.fetchedServices, ps.servicesLoading, ms.servicesLoading, ps.error, ms.error,
      gov.data, gov.governancesLoading, gov.governancesError, projectResources, projectResourcesLoading]);
};

export default useBuilderData;
